import { atom } from "recoil"

export const emailState = atom({
  key: "atoms/authorization/emailState",
  default: "",
})
